import Popup from 'react'
const sendEmail = (serviceName,templateName,templateParms) => {
return window.emailjs.send(serviceName,templateName,templateParms)
}

export const sendEmailToAdmin = (templateParms) => {
return sendEmail('default_service', 'contactme',templateParms)
}


export const sendEmailToMailer = (templateParms) => {
return sendEmail('default_service', 'template_l8cA7zaV',templateParms)
}



// WEBPACK FOOTER //
// ./src/helpers/EmailHelper.js